<template>
  <form name="passport">
    <div class="formStepTitle">
      Заполните контактную информацию <span>(шаг 2 из 3)</span>
    </div>
    <div class="passportLine_1">
      <div>
        <fmInput :refs="'PASSPORT_SERIES'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'PASSPORT_NUMBER'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'PASSPORT_DEP_CODE'"></fmInput>
      </div>
    </div>
    <div class="passportLine_2">
      <div>
        <fmInput :refs="'PASSPORT_DATE'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'BIRTHDAY'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'BIRTHPLACE'"></fmInput>
      </div>
    </div>
<div>
  <fmSelectDadataPassport :refs="'PASSPORT_DEP'"></fmSelectDadataPassport>
</div>

    <div>
      <fmSelectDadata :refs="'REGISTRATION_ADDRESS'"></fmSelectDadata>
    </div>
    <div id="adressCoincides">
      <fmCheckBox :name="'IS_ADDRESS_COINCIDES'"
                  :true-value="'Y'"
                  :false-value="'N'"
      ></fmCheckBox>
    </div>
    <div>
      <fmSelectDadata :refs="'RESIDENTIAL_ADDRESS'"></fmSelectDadata>
    </div>
    <nxtButton v-on:submitStep="submitStep"></nxtButton>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  export default {
    name: "passport",
    data(){
      return {
        refsStepArr:[
          'PASSPORT_SERIES',
          'PASSPORT_NUMBER',
          'PASSPORT_DEP_CODE',
          'PASSPORT_DATE',
          'BIRTHDAY',
          'BIRTHPLACE',
          'REGISTRATION_ADDRESS',
          'RESIDENTIAL_ADDRESS',
          'PASSPORT_DEP',
        ],
      }
    },
    components:{
      fmInput: () => import('@/components/form/fmInput'),
      nxtButton: () => import('@/components/form/nextButton'),
      fmSelectDadata: () => import('@/components/form/fmSelectDadata'),
      fmSelectDadataPassport: () => import('@/components/form/fmSelectDadataPassport'),
      fmCheckBox: () => import('@/components/form/fmCheckBox'),
    },
    mounted() {
      this.$store.dispatch('hideLoading');
      window.dblClick = false;
      window.scrollTo({
        left:0,
        top:this.$parent.$refs.formAlign.offsetTop,
        behavior: 'smooth'
      });
      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'admdPdlFio');
      }
      // if (window.ym) {
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdFioAddress');
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdChainFioAdress');
      // }
      // if (window.ga){
      //   // eslint-disable-next-line no-undef
      //   ga('send', 'event', 'admdForm', 'admdFioAddress');
      // }
    },
    methods: {
      chekRegistrationAdress: function () {
        return new Promise((resolve, reject) => {
          this.$palantir.trackAction(130,'');
          this.$myApi.SendRequest({
            action: 'chekRegistrationAdress',
            REGISTRATION_ADDRESS_DADATA: this.valueVuex.REGISTRATION_ADDRESS_DADATA,
            FIRST_NAME: this.valueVuex.FIRST_NAME,
            LAST_NAME: this.valueVuex.LAST_NAME,
            SECOND_NAME: this.valueVuex.SECOND_NAME,
            PASSPORT_SERIES: this.valueVuex.PASSPORT_SERIES,
            PASSPORT_NUMBER: this.valueVuex.PASSPORT_NUMBER,
            BIRTHDAY: this.valueVuex.BIRTHDAY,
            PHONE:this.valueVuex.PHONE
            // eslint-disable-next-line no-unused-vars
          }).then((res) => {
            this.$palantir.trackAction(131,'');
            this.$myApi.singleRequest({
              action: 'checkLog',
              value: 0
            });
            resolve();
          }).catch((res) => {
            this.$palantir.trackAction(132,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'passport chekRegistrationAdress');
            if (ErrorResult.ExecutionErrorCode > 0) {
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'admdScoringFail');
              }
              this.$store.commit('saveScrMsg', 'К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.');
              this.$myApi.singleRequest({
                action: 'checkLog',
                value: res.Response.ExecutionError.ExecutionErrorMessage
              });
              reject();
            } else {
              //случилась некая херня неожиданная, продолжаем принимать заявку
              resolve();
            }

          });
        })
      },
      adressCheck: function(){
        let result = 0;
        return new Promise((resolve, reject) => {
          this.$palantir.trackAction(122,'');
          this.$myApi.SendRequest({
            action: 'GetAddressTerritory',
            Address: this.valueVuex.RESIDENTIAL_ADDRESS
          })
          // eslint-disable-next-line no-unused-vars
          .then((res)=>{
            this.$palantir.trackAction(123,'');
            if (window.ym) {
              // eslint-disable-next-line no-undef
              ym(51632228, 'reachGoal', 'admdAdressTrue');
            }
            result = 1;
            resolve();
            // eslint-disable-next-line no-unused-vars
          }).catch((res)=>{
            this.$palantir.trackAction(124,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'passport adressCheck');
            if (ErrorResult.ExecutionErrorCode > 0) {
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'admdAdressFalse');
              }
              this.$store.commit('saveScrMsg', 'К сожалению, на данный момент ваш населённый пункт не обслуживается, но наша компания быстро расширяется, возможно, скоро появимся и у вас,  ожидайте появления наружной рекламы');
              result = -1;
              try {
                switch (res.Response.ExecutionError.ExecutionErrorCode) {
                  case 1:
                    result = -1;
                    break;
                  case 2:
                    result = -2;
                    break;
                  default:
                    result = -1;
                    break;
                }
              } catch (e) {
                result = -1;
              }
              reject();
            } else {
              //случилась некая херня неожиданная, продолжаем принимать заявку
              result = 0;
              resolve();
            }

          }).finally(()=>{
            this.$myApi.singleRequest({action:'adressZoneLog', value: result});
          });
        });
      },
      submitStep() {
        this.$store.dispatch('showLoading');
        this.$palantir.trackAction(129,'');
        if (this.checkFormFieldValue()){

          try {
            let calcAge = new Date(new Date() - new Date(this.valueVuex['BIRTHDAY'])).getFullYear() - 1970;
            if (calcAge <= 21) {
              this.$palantir.trackAction(149,this.valueVuex['BIRTHDAY'] + ' calc =' + calcAge );
              this.$palantir.trackAction(128, window.linkToMarket);
              document.location.href = window.linkToMarket;
              return false;
            }
            // eslint-disable-next-line no-empty
          } catch (e) {

          }

          this.chekRegistrationAdress()
          .then(this.adressCheck)
          .then(()=>{
            this.$store.dispatch('formRouting','srcContact');
          })
          .catch(()=>{
            if (this.doesNotRedirect) {
              if (this.doesNotRejectRequest) {
                this.$palantir.trackAction(126,JSON.stringify({
                  doesNotRedirect: this.doesNotRedirect,
                  doesNotRejectRequest: this.doesNotRejectRequest
                }));
                this.$store.dispatch('formRouting','srcContact');
              } else {
                this.$palantir.trackAction(127,JSON.stringify({
                  doesNotRedirect: this.doesNotRedirect,
                  doesNotRejectRequest: this.doesNotRejectRequest
                }));
                this.$store.dispatch('formRouting','scrEndError');
              }
            } else {
              this.$palantir.trackAction(128,window.linkToMarket);
              document.location.href = window.linkToMarket;
            }
            this.$store.dispatch('hideLoading');
          });
        } else {
          window.dblClick = false;
          this.$store.dispatch('hideLoading');
        }
      },
      checkFormFieldValue(){
        //проверяем заполнения полей

        let isFormFieldCorrect = true;

        let checkAdress = this.isAdressValid('REGISTRATION_ADDRESS');

        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError',{
            target: 'REGISTRATION_ADDRESS',
            value: checkAdress
          });
          isFormFieldCorrect =  false;
          this.$palantir.trackAction(116,'REGISTRATION_ADDRESS');
        }
        checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError',{
            target: 'RESIDENTIAL_ADDRESS',
            value: checkAdress
          });
          isFormFieldCorrect =  false;
          this.$palantir.trackAction(116,'RESIDENTIAL_ADDRESS');
        }

        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$palantir.trackAction(117,item);
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            isFormFieldCorrect = false;
          }
        });
        return isFormFieldCorrect;
      }
    },
    computed:{
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData
      }),
      ...mapGetters([
        'getRedirectUrl','doesNotRedirect','doesNotRejectRequest','isAdressValid'
      ]),
    },
  }
</script>

<style scoped>

/deep/#adressCoincides label{padding: 4vw 0;}
/deep/#adressCoincides label input{}
/deep/#adressCoincides .visualCheckBox{border: 1px solid #0a4d3a}
/deep/#adressCoincides .visualCheckBox svg{stroke: #0a4d3a}
@media screen and (min-width: 760px) {
  /deep/#adressCoincides label{justify-content: flex-start;padding: 1vw 1.1vw 1.5vw;}
  /deep/#adressCoincides label input{}

  .passportLine_1{display: flex;align-items: center;justify-content: space-between;}
  .passportLine_1 > div{width: 33%;}
  .passportLine_2{display: flex;align-items: center;justify-content: space-between;}
  .passportLine_2 > div{width: 20%;}
  .passportLine_2 > div:last-child{width: 59%;}
}
@media screen and (min-width: 1140px) {
  /deep/#adressCoincides label{padding: 10px 13px 15px;}
  /deep/#adressCoincides label input{}
}
</style>
